var _mask, _g, _path, _mask2, _g2, _mask3, _g3, _mask4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresssuitBottom = function SvgPresssuitBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-bottom_svg__a",
    width: 32,
    height: 24,
    x: 2,
    y: 7,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 7.098h32v23.319H2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-bottom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "m2.023 22.646-.015.052h.012c-.085 2.59.094 5.177.577 7.719H17.37l.541-2.483h.16l.54 2.483H33.39c.487-2.542.672-5.128.592-7.718l.012-.001-.015-.052-3.637-15.548h-24.7z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "M2.009 22.698s4.375.226 8.253 1.237c2.628.685 5.243 2.74 6.656 3.996a1.616 1.616 0 0 0 2.15 0c1.414-1.255 4.029-3.31 6.656-3.996 3.879-1.011 8.272-1.237 8.272-1.237l-3.654-15.6h-24.7z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-bottom_svg__b",
    width: 32,
    height: 22,
    x: 2,
    y: 7,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.643 7.098-3.634 15.6s4.375.226 8.253 1.237c2.628.685 5.243 2.74 6.656 3.995a1.615 1.615 0 0 0 2.15 0c1.414-1.255 4.029-3.31 6.656-3.995 3.879-1.01 8.272-1.237 8.272-1.237l-3.654-15.6",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-bottom_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E64909",
    strokeWidth: 2,
    d: "m7.71 21.424 3.274-14.326-.565-5.472"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-bottom_svg__c",
    width: 32,
    height: 22,
    x: 2,
    y: 7,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.643 7.098-3.634 15.6s4.375.226 8.253 1.237c2.628.685 5.243 2.74 6.656 3.995a1.615 1.615 0 0 0 2.15 0c1.414-1.255 4.029-3.31 6.656-3.995 3.879-1.01 8.272-1.237 8.272-1.237l-3.654-15.6",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-bottom_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E64909",
    strokeWidth: 2,
    d: "m18.006 22.961-.008-15.864H18l.008-8.208"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "presssuit-bottom_svg__d",
    width: 32,
    height: 22,
    x: 2,
    y: 7,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.643 7.098-3.634 15.6s4.375.226 8.253 1.237c2.628.685 5.243 2.74 6.656 3.995a1.615 1.615 0 0 0 2.15 0c1.414-1.255 4.029-3.31 6.656-3.995 3.879-1.01 8.272-1.237 8.272-1.237l-3.654-15.6",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#presssuit-bottom_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E64909",
    strokeWidth: 2,
    d: "m25.59 1.626-.565 5.472 3.27 14.326"
  }))));
};
export default SvgPresssuitBottom;